export const EVENT_DETAILS_FEATURE_GATE = 'listings_ssr_event_details';
export const DISPLAY_ORGANIZER_RATING_GATE = 'listing_display_organizer_rating';
